import CreateList from './CreateList';
import { withI18n } from 'react-i18next';

export default withI18n()(CreateList);
